import { render, staticRenderFns } from "./AppTruncateText.vue?vue&type=template&id=4b9201f0&scoped=true&"
import script from "./AppTruncateText.vue?vue&type=script&lang=js&"
export * from "./AppTruncateText.vue?vue&type=script&lang=js&"
import style0 from "./AppTruncateText.vue?vue&type=style&index=0&id=4b9201f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b9201f0",
  null
  
)

export default component.exports